import './App.css';
import { Helmet } from 'react-helmet';
import { Route, Switch, BrowserRouter } from 'react-router-dom';

import { Login, Forgot, MigrateWarning } from './auth';

const App = () => (
  <>
    <Helmet title={process.env.REACT_APP_NAME}>
      <html lang='en' />
      <meta
        name='viewport'
        content='width=device-width, initial-scale=1, shrink-to-fit=no'
      />
      <link rel='icon' href={require('assets/img/favicon.ico')} />
      <link
        href='https://fonts.googleapis.com/css?family=Roboto:400&display=swap'
        rel='stylesheet'
      />
    </Helmet>
    <BrowserRouter basename={process.env.REACT_APP_BASE_PATH}>
      <Switch>
        <Route path='/' component={Login} />
        <Route path={process.env.REACT_APP_FORGOT_PATH} component={Forgot} />
        <Route path={process.env.REACT_APP_MIGRATE_PATH} component={MigrateWarning} />
      </Switch>
    </BrowserRouter>
  </>
);

export default App;
